import styled from 'styled-components'
import { devices } from '../../../utils/screen_sizes'
import { solidBlack } from '../../../utils/colors'

export const StyledMarkettingSection = styled.section`
    .marketting-card {
        background: white;
        display: grid;
        grid-template-areas: 'image' 'text';
        justify-content: center;
        background-image: url('/assets/images/markettingSection/stars.svg');
        margin: 64px 8px;
        border-radius: 16px;
        box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.06),
            0px 6px 10px 0px rgba(0, 0, 0, 0.042),
            0px 1px 18px 0px rgba(0, 0, 0, 0.036);
        > div {
            display: flex;
            flex-direction: column;
            alignt-items: center;
            justify-content: center;
            margin: auto;
        }

        @media ${devices.tablet} {
            width: 80vw;
            border-radius: 40px;
            margin: 64px auto;
        }
        @media ${devices.laptop} {
            width: 80vw;
            grid-template-rows: none;
            grid-template-columns: 2fr 2fr;
            grid-template-areas: 'text image';
        }

        @media ${devices.desktop} {
            width: 60vw;
            grid-template-rows: none;
            grid-template-columns: repeat(2, 1fr);
            grid-template-areas: 'text image';
        }
    }
`
export const StyledPartnerSection = styled.section`
   padding: 35px 0;
   background:  #fafafa;

      @media ${devices.mobileS} {
       padding:  0;
          background: transparent;
        }
      @media ${devices.laptop} {
        padding: 35px 0;
        }
        .z-flip-secion {
        background-image: url('/assets/images/markettingSection/mid-banner_samsung.png');
     background-position: center;
            /* padding: 2rem; */
            background-size: contain;
             background-repeat: no-repeat;
        }

    .partner-card {
        background-image: url('/assets/images/markettingSection/mid-banner_samsung.png');
        min-height: 650px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
             
        @media ${devices.mobileS} {
            background-image: url('/assets/images/markettingSection/mid-banner-mobile.png');
            background-position: center;
                 min-height: 400px;
            background-size: contain;
        }
        @media ${devices.mobileM} {
            background-image: url('/assets/images/markettingSection/mid-banner-mobile.png');
            background-position: center;
             min-height: 400px;
            background-size: contain;
        }
        @media ${devices.tabletL} {
            background-image: url('/assets/images/markettingSection/mid-banner_samsung.png');
            background-position: center;
            min-height: 550px;
            background-size: contain;
        }
       
        @media ${devices.laptopL} {
            background-image: url('/assets/images/markettingSection/mid-banner_samsung.png');
            position: relative;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: contain;
              min-height: 650px;
    }
        
 
       

`

export const StyledPartnerButton = styled.button`
    position: absolute;
    left: 20%;
    bottom: 50px;
    border: 0;
    color: #fff;
    background-color: #42c8b7;
    padding: 7px 9px;
    width: 10%;
    border-radius: 1rem;
    cursor: pointer;
    font-weight: bold;
    font-size: .8rem;

    @media ${devices.mobileS} {
        position: relative;
        width: 60%;
        margin: 3rem auto 0rem;
    }

    @media ${devices.mobileM} {
        width: 40%;
        margin: 4rem auto 0rem;
        bottom: 44px;
        left: 30%;
        padding: 0.55rem 0;
    }
    @media ${devices.mobileL} {
        width: 22%;
        margin: 4rem auto 0rem;
        bottom: 44px;
        left: 15%;
        bottom: 35px;
        padding: 0.55rem 0;
    }
    @media ${devices.tablet} {
        width: 25%;
        margin: -0.5rem auto;
        bottom: 50px;
        left: 18%;
    }
    @media ${devices.laptop} {
        width: 12%;
        margin: 0rem auto;
        left: 24%;
        position: absolute;
        bottom: 65px;
        padding: 0.55rem 0;
    }
`

export const StyledMarkettingText = styled.div`
    flex-direction: column;
    grid-area: text;
    padding: 2em;
`

export const StyledMarkettingImage = styled.div`
    width: 100%;
    grid-area: image;

    > div {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    img {
        width: 90%;
    }

    @media ${devices.mobileM} {
        img {
            width: 60%;
        }
    }
    @media ${devices.tablet} {
        img {
            width: 60%;
        }
    }
    @media ${devices.tabletL} {
        img {
            width: 50%;
        }
    }
    @media ${devices.laptop} {
        img {
            width: 80%;
        }
    }
    @media ${devices.desktop} {
        img {
        }
    }
`

export const StyledMarkettingHeading = styled.h2`
    color: ${solidBlack};
`

export const BulletPoint = styled.div`
    display: flex;
    flex-direction: row;
    padding: 16px;

    div {
        padding-left: 16px;
    }

    span {
        color: #54beb6;
    }

    h4 {
        color: ${solidBlack};
    }

    p {
        color: ${solidBlack};
    }
`
